import { render, staticRenderFns } from "./ManageProjectCode.vue?vue&type=template&id=18963db5"
import script from "./ManageProjectCode.vue?vue&type=script&lang=js"
export * from "./ManageProjectCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports